export const quantityCounterComponent = {
  key: 'quantityCounterComponent',
  name: 'Quantity Counter Component',
  siteIdentifier: 'global',

  decreaseQuantityAlt: 'Decrease quantity by 1',
  increaseQuantityAlt: 'Increase quantity by 1',
  quantityAlt: 'Quantity',
};
